import {
  useGetIntegrationDataQuery,
  useGetIntegrationsQuery,
} from '@carboncopyco/data';
import type { IntegrationVendor } from '@carboncopyco/types';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useParams } from 'react-router-dom';

type UseIntegrationProps = {
  integrationType: IntegrationVendor;
  organizationId?: number | string;
};

type UseIntegrationOptions = { skip?: boolean };

export const useIntegration = (
  { integrationType, organizationId }: UseIntegrationProps,
  options?: UseIntegrationOptions
) => {
  const flags = useFlags();
  const { skip } = options || {};

  const { organizationId: organizationFromParams } = useParams();
  const { data: integrations } = useGetIntegrationsQuery(
    {
      organizationId: organizationId
        ? Number(organizationId)
        : Number(organizationFromParams),
    },
    { skip }
  );
  const integration = integrations?.find(
    (integration) => integration.integrationType === integrationType
  );
  const integrationId = integration?.id;

  const { data: integrationData } = useGetIntegrationDataQuery(
    {
      organizationId: organizationId
        ? Number(organizationId)
        : Number(organizationFromParams),
      integrationId: integrationId!,
    },
    {
      skip:
        flags.hubspotCrm ||
        integrationType !== 'salesforce' ||
        !integrationId ||
        integration?.renewalRequired ||
        integration?.paused,
    }
  );
  const paused = integration?.paused;
  const renewalRequired = integration?.renewalRequired;
  const disabled = paused || renewalRequired || !integrationId;

  return {
    paused,
    integrationId,
    activeOpportunities: flags.hubspotCrm
      ? undefined
      : integrationData?.activeOpportunities,
    renewalRequired,
    disabled,
  };
};
